/* cwclientelements
   copyright 2019 LOGILAB S.A. (Paris, FRANCE), all rights reserved.
   contact http://www.logilab.fr/ -- mailto:contact@logilab.fr
*/

import * as React from 'react';
import {getDisplayText} from './commons';
import {
    EntityAttribute,
    EntityAttributeProps,
    ENTITY_ATTRIBUTE_DEFAULT_PROPS,
} from './EntityAttribute';
import {DefaultEntityAttribute} from './DefaultEntityAttribute';

export interface RichStringEntityAttributeProps extends EntityAttributeProps {
    format: string;
}

/**
 * The default props for a string entity attribute
 */
export const RICHSTRING_ENTITY_ATTRIBUTE_DEFAULT_PROPS = {
    ...ENTITY_ATTRIBUTE_DEFAULT_PROPS,
    format: 'text/plain',
    renderTitle: (component: RichStringEntityAttribute) => {
        return (
            <span>
                {component.context.translate(component.props.attribute.name)}(
                {component.props.format})
            </span>
        );
    },
    onFieldInputEnded: (component: EntityAttribute, input: string) => {
        if (
            input.length === 0 &&
            !component.props.isRequired(component.props.attribute)
        ) {
            // the new value is empty and not required
            // => convert to unset value
            return component.props.onFieldEditedValue(component, null);
        }
        component.props.onFieldEditedValue(component, input);
    },
    renderInput: (component: EntityAttribute) => {
        let text = getDisplayText(component.state.value);
        return (
            <textarea
                value={text}
                disabled={component.props.disabled}
                required={component.props.isRequired(component.props.attribute)}
                onChange={(event) =>
                    component.props.onFieldChange(component, event)
                }
                onBlur={(event) =>
                    component.props.onFieldBlur(component, event)
                }
            ></textarea>
        );
    },
};

/**
 * Component for rendering a string entity attribute
 */
export class RichStringEntityAttribute extends React.Component<RichStringEntityAttributeProps> {
    public static defaultProps = RICHSTRING_ENTITY_ATTRIBUTE_DEFAULT_PROPS;

    render() {
        return <DefaultEntityAttribute {...this.props} />;
    }
}
